import { createContext } from "react";
import { CartState, DispatchCartAction } from "@States/cart";
import { Configuration } from "@Types/cart";

export interface CartContextType extends CartState {
  configuration: Configuration;
  dispatch: DispatchCartAction;
}

const CartContext = createContext<CartContextType>({} as CartContextType);

export default CartContext;
